<script setup>
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import { onMounted, ref } from 'vue';
import YoutubeFeaturedVideoComponent from '../Home/YoutubeFeaturedVideoComponent.vue';
const { locale } = useI18n();

const service_steps = ref([]);

async function getServiceSteps() {
    try {
        const res = await axios.get('/get-service-steps-data');
        service_steps.value = res.data || [];
    } catch (error) {
        console.error('Error fetching :', error);
    }
}

onMounted(() => {
    getServiceSteps();
})
</script>
<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 pb-4 mx-auto">
            <div class="pb-8 wow animate__animated animate__fadeInLeft">
                <h2 class="sm:w-1/2 w-full text-center text-black leading-tight mx-auto font-roboto title-font xl:text-[44px] lg:text-[36px] sm:text-[28px] text-xl mt-4 sm:mb-6 mb-4">
                    {{ $t('home.how_to_access') }}</h2>
                <div class="mx-auto border-[3.5px] border-transparent border-t-[#1cbed1] w-36"></div>
            </div>

            <div class="flex flex-wrap w-full">
                <YoutubeFeaturedVideoComponent/>

                <div class="xl:w-2/5 lg:w-1/2 w-full mt-8 wow animate__animated animate__fadeInRight">
                    <div class="flex relative pb-9" v-for="(item,index) in service_steps" :key="index">
                        <div class="h-full w-9 absolute inset-0 flex items-center justify-center">
                            <div class="h-full border-dashed border border-primary" :class="{'border-none': index === service_steps.length - 1}"></div>
                        </div>
                        <div
                            class="flex-shrink-0 w-9 h-9 rounded-full bg-primary inline-flex items-center justify-center text-white text-lg z-10">
                            {{index+1}}
                        </div>
                        <div class="flex-grow pl-4">
                            <p class="text-black lg:text-[19px] text-base font-light leading-relaxed" v-html="locale === 'BN' ? item?.bn_title : item?.title"></p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>
<style scoped></style>
